export enum Role {
    TelekomAdminUser = "http://magentaclub/telekom-admin",
    ITAdminUser = "http://magentaclub/it-admin",
    PartnerUser = "http://magentaclub/partner-admin",
    PosUser = "http://magentaclub/pos-user",
    Dummy = "http://magentaclub/dummy"
}
